module.exports = __webpack_public_path__ + "img/flag-np.4d69de04.png";